import NextImage from '@/components/image';
import CurrencyIcon from '@/components/ui/icons/currency-icon';
import useHandleCart from '@/hooks/cart/useHandleCart';
import { validatePrice } from '@/utils/category';
import { handlePriceByComma } from '@/helpers/common';
import NextLink from '@/components/next-link';

const RelatedProduct = ({ item, t }) => {
  const productName = Array.isArray(item?.name) ? item?.name?.[0] : item?.name;
  const { handleAddToCart, loading } = useHandleCart();
  const isAddedToCart = loading === 'adding';

  const prices = validatePrice(item?.prices_with_tax);
  return (
    <div
      key={item.item_id}
      className='flex w-full min-w-[113px] flex-col gap-1.5 rounded-xl border border-[#e2e8f0] bg-[#f8fafc] p-2'
      data-id={item.id}
      data-price={item.price}
    >
      <div className='h-26 w-23.75 rounded-lg border-2 border-[#e2e8f0] bg-white p-1'>
        <NextImage
          src={item?._media_?.image?.at(0)?.image || item?.image_url}
          alt={item.title}
          loading='lazy'
          width={95}
          height={104}
          className='h-full w-full object-contain'
        />
      </div>
      <NextLink
        href={item?.innova_url ? `/${item?.innova_url}` : '#'}
        className='h-[31px] overflow-hidden text-[12px] leading-[1.3]'
      >
        {productName}
      </NextLink>
      <div className='flex items-center gap-1 font-extrabold'>
        {handlePriceByComma(prices?.specialPrice || prices?.originalPrice)}{' '}
        <CurrencyIcon className='size-3' />
      </div>
      <button
        onClick={() => handleAddToCart(item, 1, t)}
        className='text-primary rounded-[10px] p-2 font-bold'
      >
        {isAddedToCart ? (
          <div className='mx-auto size-4 animate-spin rounded-full border-t border-r border-[#aaa] py-1 text-center' />
        ) : (
          t('add')
        )}
      </button>
    </div>
  );
};

export default RelatedProduct;
